<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/stvjqd/tc-custom/9781466845374.jpg?1719550987707" alt="This image is the cover for the book Witch Hunter's Tale, The Midwife's Tale"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Witch Hunter's Tale, The Midwife's Tale
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Sam Thomas's <i>The Witch Hunter's Tale</i> takes readers back to Puritan England with midwife Bridget Hodgson, hailed by the<i>Cleveland Plain Dealer</i> as "one of the most fascinating detectives in contemporary mystery fiction."</b><br/><br/>Winter has come to the city of York, and with it the threat of witchcraft. As women and children sicken and die, midwife Bridget Hodgson is pulled against her will into a full-scale witch-hunt that threatens to devour all in its path, guilty and innocent alike. <br/>Bridget—accompanied once again by her deputy Martha Hawkins and her nephew Will Hodgson—finds herself playing a lethal game of cat and mouse against the most dangerous men in York, as well as her sworn enemy Rebecca Hooke. As the trials begin, and the noose begins to tighten around her neck, Bridget must answer the question: How far will she go to protect the people she loves?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sam Thomas
      </h2>
      
      <p class="authorDescription body article"><P>SAM THOMAS teaches history at University School near Cleveland, Ohio. He has received research grants from the National Endowment for the Humanities, the Neweberry Library, and the British Academy. He has published academic articles on topics ranging from early modern Britain to colonial Africa. Thomas lives in Shaker Heights, Ohio, with his wife and two children.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?03cc8f16